module.exports = __webpack_public_path__ + "img/PRNT_06_mono_AE_00003.49c3c408.png";